import React from 'react'
import { IconButton, createStyles, withStyles } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { expandNavBreakpoint } from '../../styles'

const styles = (theme) => {
  return createStyles({
    button: {
      [theme.breakpoints.up(expandNavBreakpoint)]: {
        display: 'none',
      },
    },
  })
}

const ShowMenu = ({ classes, showMenu }) => {
  return (
    <IconButton
      onClick={showMenu}
      aria-label="open menu"
      className={classes.button}
    >
      <MenuIcon />
    </IconButton>
  )
}

export default withStyles(styles)(ShowMenu)
